export default "__VITE_ASSET__b97a2884__"